import type { CellContext } from '@/components/ui/table/types'
import type { Statement } from '@/modules/projects'

export const NumberOfPagesCell = (cell: CellContext<Statement, string>) => (
  <div className="text-left">{cell.getValue()}</div>
)
